module.exports = __webpack_public_path__ + "static/media/loc6_img13.91d55890.jpg";